module.exports = __webpack_public_path__ + "img/copart.034e8e6e.png";